import { isPast } from 'date-fns';

import isDev from '@/constants/isDev';

/** サービス終了のお知らせを表示開始する日時 */
export const SHOW_SERVICE_TERMINATION_NOTICE_DATE = new Date(
  '2025-04-30T13:00:00+09:00'
);

/** サービス終了のお知らせを表示するかどうか */
export const SHOW_SERVICE_TERMINATION_NOTICE =
  isDev || isPast(SHOW_SERVICE_TERMINATION_NOTICE_DATE);

/** サービス終了のお知らせの詳細ウェブページのURL */
export const SERVICE_TERMINATION_DETAILS_URL = {
  JA: 'https://www.notion.so/ANIFTY-c7c9a6b902744cafaa8159e9c2d34780',
  EN: 'https://www.notion.so/Notice-of-Termination-of-ANIFTY-EN-ff9a2c79042c4749bb2af61712c3d47c',
} as const;

/** 出品機能終了日時 */
export const LISTING_FEATURE_END_DATE = new Date('2025-05-31T23:59:59+09:00');

/** 出品機能終了日時を過ぎているかどうか */
export const IS_LISTING_FEATURE_END = isPast(LISTING_FEATURE_END_DATE);

/** 購入機能終了日時 */
export const PURCHASE_FEATURE_END_DATE = new Date('2025-06-15T23:59:59+09:00');

/** 購入機能終了日時を過ぎているかどうか */
export const IS_PURCHASE_FEATURE_END = isPast(PURCHASE_FEATURE_END_DATE);

/** サービス終了日時 */
export const SERVICE_TERMINATION_DATE = new Date('2025-06-30T23:59:59+09:00');
